export * from "ce/selectors/applicationSelectors";
import type { DefaultRootState } from "react-redux";
import type { WorkspaceUserRoles } from "ee/constants/workspaceConstants";
import { createSelector } from "reselect";

export const getAllAppUsers = (state: DefaultRootState) =>
  state.ui.applications.applicationUsers;

export const getAllAppRoles = (state: DefaultRootState) =>
  state.ui.applications.applicationRoles;

export const getAppRolesForField = createSelector(
  getAllAppRoles,
  (roles: WorkspaceUserRoles[] = []) => {
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return roles.map((role: any) => {
      return {
        id: role?.id,
        name: role?.name,
        description: role?.description,
      };
    });
  },
);
